<template>
  <v-card
    outlined
    class="my-2"
    loader-height="8"
    :loading="admin.attributesLoading"
    :disabled="admin.attributesLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <v-toolbar color="blue lighten-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.detailIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedAttribute == null"></v-card-text>
    <v-card-text v-show="admin.selectedAttribute != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Attribute saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field disabled v-model="id" label="ID" readonly></v-text-field>
        <v-text-field
          v-model="name"
          :rules="validation.length50"
          label="Name"
          required
        ></v-text-field>
        <v-text-field
          v-model="description"
          :rules="validation.length250"
          label="Description"
          required
        ></v-text-field>
        <v-autocomplete
          :items="admin.controlTypeList"
          label="Control Type"
          outlined
          item-text="name"
          item-value="value"
          v-model="controlType"
          :rules="validation.selection"
          autofocus
        ></v-autocomplete>
        <v-textarea
          outlined
          v-model="sigMessage"
          label="Sig Message"
        ></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedAttribute != null">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveAttribute"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <!-- <v-btn icon color="error" @click="confirmDeleteProduct"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      > -->
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmDelete: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit';
          if (
            this.admin.selectedAttribute &&
            this.admin.selectedAttribute.id != 'new'
          ) {
            tabName = `Edit Attribute [${this.admin.selectedAttribute.name}]`;
          } else if (
            this.admin.selectedAttribute &&
            this.admin.selectedAttribute.id == 'new'
          ) {
            tabName = 'Add New Attribute';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedAttribute?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttribute',
            property: 'id',
            value: value
          });
        }
      },
      name: {
        get() {
          return this.admin.selectedAttribute?.name;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttribute',
            property: 'name',
            value: value
          });
        }
      },
      description: {
        get() {
          return this.admin.selectedAttribute?.description;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttribute',
            property: 'description',
            value: value
          });
        }
      },
      sigMessage: {
        get() {
          return this.admin.selectedAttribute?.sigMessage;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttribute',
            property: 'sigMessage',
            value: value
          });
        }
      },
      controlType: {
        get() {
          return this.admin.selectedAttribute?.controlType;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedAttribute',
            property: 'controlType',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedAttribute', null);
        this.$store.commit(
          'admin/setCurrentAttributeTab',
          this.admin.ATTRIBUTE_TABS.LIST
        );
      },
      /**
       * Saves the product currently being edited
       */
      saveAttribute() {
        this.$store.dispatch('admin/saveSelectedAttribute').then(() => {
          this.showSaveOverlay = true;
          // refresh product list
          this.$store.dispatch('admin/getAttributeList');
          setTimeout(() => {
            this.showSaveOverlay = false;
          }, 1500);
        });
      }
    }
  };
</script>

<style scoped></style>
